import React, { useEffect } from "react";
import { Form } from "antd";
import { ObjectSelect } from "../../../../Select";
import { prescriptionFields } from "../../Pfizer/form/fieldNames";
import { useSelector } from "react-redux";
import { selectAssistanceProgramDrugs } from "../../../../../store/selector";
import _ from "lodash";
import { getDrugByCui } from "../../Pfizer/form/formSections/prescription/drugDefinitions";

export const PrescriptionItem = ({ label, name, placeholder, required, rules }) => {
  const form = Form.useFormInstance();
  const drug = Form.useWatch(prescriptionFields.drug, form);

  const rxnormDrugs = useSelector(selectAssistanceProgramDrugs);

  const drugOptions =
    _.compact(
      rxnormDrugs?.map((rxnormDrug) => {
        const drugByCui = getDrugByCui(rxnormDrug.ttyCui);
        if (_.isEmpty(drugByCui)) return;
        return {
          ...rxnormDrug,
          ...drugByCui
        };
      })
    ) || [];

  // Runs a validation for the sections that opens after changing one of the dependencies value
  useEffect(() => {
    form.validateFields();
  }, [drug]);

  return (
    <Form.Item rules={[{ required }, ...rules]} label={label} name={name}>
      <ObjectSelect
        options={drugOptions}
        placeholder={placeholder}
        fieldNames={{
          label: "tmDisplayName",
          value: "ttyCui"
        }}
      />
    </Form.Item>
  );
};
